<template>
  <div :class="$style['news']">
    <NewsPageMobile v-if="isMobile"/>
    <NewsPageWeb v-else/>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import NewsPageMobile from './NewsPageMobile.vue'
import NewsPageWeb from './NewsPageWeb.vue'
export default {
  name: '',
  components: {
    NewsPageMobile,
    NewsPageWeb
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['isMobile'])
  },
  created () {
    sensors.track('page_general', {
      page_name: '官网新闻页面'
    })
  },
  mounted () {
  },
  watch: {
  },
  methods: {}
}
</script>
<style lang='scss' module>
.news {
color: #000;
}
</style>
